(ns nl.mediquest.ui.core.body
  (:require
   [clojure.spec.alpha :as s]
   [integrant.core :as ig]
   [nl.mediquest.ui.component :as component]
   [nl.mediquest.ui.html.breadcrumbs :as breadcrumbs]))

(defn view
  [{:body/keys [components show-breadcrumbs? breadcrumbs container-padding]}
   context
   params]
  [:div.flex-grow.relative
   (when (or show-breadcrumbs?
             (nil? show-breadcrumbs?)) ; show by default when absent
     [:div.bg-white.py-3
      [:div.container.mx-auto.flex.justify-between.items-center.px-2
       [breadcrumbs/view context breadcrumbs]]])
   [:div.container.mx-auto {:class (or container-padding "py-8")}
    [:div.md:flex
     [:div.w-full
      [:div.flex.flex-wrap.justify-center.sm:justify-start
       (component/render-components components context params)]]]]])

(s/def :body/components
  (s/coll-of fn?))

(defmethod ig/assert-key :component.ui/body [_k v]
  (assert (s/valid? (s/keys :req [:body/components]) v)))

(defmethod ig/init-key :component.ui/body
  [_ opts]
  (fn [context params]
    [view opts context params]))
